<template>
  <div class="dynamics">
    <!-- 查询条件 -->
    <div class="search">
      <div class="search-product">
        <div class="title">产品：</div>
        <div class="list">
          <div 
            class="list-item" 
            v-for="item in productList" 
            :key="item._id" @click="handleProductClick(item)"
            :class="{'active': searchParams.productionId === item._id}"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="search-date">
        <div class="title">日期：</div>
        <div class="list search-input">
          <el-date-picker
            class="search_range"
            @change="handleDateChange"
            v-model="timer"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placeholder="选择日期范围">
          </el-date-picker>
        </div>
      </div>
    </div>
    <!-- 表格 -->
   <div class="table">
     <el-table 
      v-loading="tableLoading" 
      ref="multipleTable"
      :data="dynamicList" 
      tooltip-effect="dark" 
      border 
      width="100%"
      class="v2table">
      <el-table-column type="index" width="80" label="序号"></el-table-column>
      <el-table-column prop="production" width="150" label="产品"></el-table-column>
      <el-table-column prop="htmlText" label="更新摘要"></el-table-column>
      <el-table-column prop="version" width="100" label="版本"></el-table-column>
      <el-table-column prop="displayTime" width="120" label="更新日期"></el-table-column>
      <el-table-column label="详情" width="100">
        <template scope="scope">
          <el-button class="btn-blue" size="mini" @click="handleDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
   </div>
    <!-- 分页 -->
    <el-pagination
      background
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
      :current-page="pageNum" 
      :page-sizes="[10, 20, 30, 40]" 
      :page-size="pageSize" 
      layout="sizes, total, prev, pager, next, jumper" 
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
  import moment from 'moment';
  import { mapActions, mapState } from 'vuex';
  import { clearTag } from '../../utils/util';
  export default {
    name:'ProductDocument',
    data() {
      return {
        productList:[],//产品列表
        dynamicList:[],//动态列表
        timer:[],
        searchParams:{
          "category": "",   //产品端  B端:"2B" C端:"2C
          "productionId":"", //关联的产品类型
          "startTime":"",  //开始时间
          "endTime":"",  //结束时间
        },
        tableLoading:false,
        pageSize:10,
        pageNum:1,
        total:0,
      };
    },
    computed: {
      ...mapState({
        currentClient: state=>state.User.currentClient,
      })
    },
    created() {
      this.getTime();
      //获取产品列表
      this.getProductionClientInfo();
      //获取动态列表
      this.getDynamicClientInfo();
    },
    // 清空时间选择器，赋默认值
    watch: {
      timer(val, oldVal) {
        if (!val) {
          this.getTime();
          this.getDynamicClientInfo();
        }
      }
    },
    components: {},
    methods: {
      ...mapActions(['productionClientInfo', 'dynamicClientInfo']),
      // 日期选择
      handleDateChange(val){
        if(val && val.length > 0){
          this.getDynamicClientInfo();
        }
      },
      getTime(){
        // 获取近3个月时间段
        const now = new Date();
        const threeMonthAgo = new Date(now.setMonth(now.getMonth() - 3));
        this.timer = [threeMonthAgo, new Date()];
      },
      // 分页
      handleSizeChange(size) {
        this.pageSize = size;
        this.getDynamicClientInfo();
      },
      handleCurrentChange(pageNum) {
        this.pageNum = pageNum;
        this.getDynamicClientInfo();
      },
      // 产品点击事件
      handleProductClick(item){
        this.searchParams.productionId = item._id;
        this.getDynamicClientInfo();
      },
      // 详情
      handleDetail(row){
        this.$router.push({
          path: '/dynamics/detail',
          query: {
            id: row._id
          }
        });
      },
      // 获取产品动态列表
      getDynamicClientInfo(){
        const params = {
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
          "productionId": this.searchParams.productionId, //产品id
          p: this.pageNum,
          s: this.pageSize   //如果是首页需要五条需要传  p和s
        };
        if(this.timer && this.timer.length > 0){
          if(this.timer[0] && this.timer[1]){
            params.startTime = moment(this.timer[0]).format('YYYY-MM-DD');
            params.endTime = moment(this.timer[1]).format('YYYY-MM-DD');
          }else{
            params.startTime = '';
            params.endTime = '';
          }
        }
        this.tableLoading = true;
        this.dynamicClientInfo(params).then(res => {
          const arr = res.items;
          this.dynamicList = arr.map(item=>{
            let htmlText = clearTag(item.contents);
            if(htmlText && htmlText.length >= 30) {
              item.htmlText = htmlText.slice(0, 30) + '...';
            }else{
              item.htmlText = htmlText;
            }
            return item;
          })
          this.total = res.total;
        }).finally(()=> {
          this.tableLoading = false;
        });
      },
      // 获取产品列表
      getProductionClientInfo(){
        this.productionClientInfo({
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        }).then(list => {
          this.productList = list;
          this.productList.unshift({
            name:'全部',
            _id:''
          });
          console.log('this.productList :>> ', this.productList);
        })
      }
    }
  };
</script>
<style>
</style>
<style lang="sass" rel="stylesheet/scss" scoped>
   .dynamics{ 
    min-height: 560px;
    width: 100%;
    background-color: #fff;
    padding: 20px 30px;
    .search{
      margin-bottom: 30px;
      .title{
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;
      }
      &-product{
        display: flex;
        .list{
          display: flex;
          flex-wrap: wrap;
          &-item{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 26px;
            font-size: 14px;
            color: #333;
            border: 1px solid #ddd;
            cursor: pointer;
            min-width: 70px;
            margin-right: 10px;
            border-radius: 4px;
            padding: 5px;
            &:hover{
              background-color: #1daef8;
              border: 1px solid #1daef8;
              color: #fff;
            }
          }
          $-item::last-child{
            margin-right: 0;
          }
          .active{
            background-color: #1daef8;
            border: 1px solid #1daef8;
            color: #fff;
          }
        }
      }
      &-date{
        display: flex;
        margin-top: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?9c0edfac